import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '@app/services/account.service';
import { AuthStore } from '@app/stores/auth.store';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-enable-two-factor-auth',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    InfoLabelComponent,
    ValidatedInputComponent,
  ],
  templateUrl: './enable-two-factor-auth.component.html',
  styleUrl: './enable-two-factor-auth.component.scss',
})
export class EnableTwoFactorAuthComponent {
  protected code: string = '';
  protected qrCode: string = '';
  protected formGroup: FormGroup<{ code: FormControl<string> }>;

  protected store = inject(AuthStore);

  constructor(
    private accountService: AccountService,
    private router: Router,
    fb: FormBuilder
  ) {
    accountService.enable2fa().subscribe((response) => {
      this.code = response.manualKey;
      this.qrCode = response.qrCodeUri;
    });

    this.formGroup = fb.group({
      code: fb.nonNullable.control('', Validators.required),
    });
  }

  onSubmit(): void {
    if (this.formGroup.invalid) {
      return;
    }

    this.accountService
      .verify2fa({ code: this.formGroup.controls.code.value })
      .subscribe((response) => {
        this.store.refreshUserProfile().subscribe(() => {
          const returnUrl =
            this.router.routerState.snapshot.root.queryParams['returnUrl'] ??
            '/profile';
          this.router.navigateByUrl(returnUrl);
        });
      });
  }

  protected copyCode(): void {
    navigator.clipboard.writeText('Your text to copy');
  }
}
